import React from "react";
import './Spinner2.css'

const spinner = () => (
	<div className = 'Loader' >
		Loading...
	</div>
);

export default spinner;